module.exports = __webpack_public_path__ + "static/media/provider-1.df1b0e27.jpg";